"use client";

// Finishes a social login on the page it started from (MLC-2674); see utils/socialLoginHistoryUtils.
import { resumeSocialLoginRedirect } from "@/utils/socialLoginHistoryUtils";
import { useEffect } from "react";

const SocialLoginHistoryResume = () => {
  useEffect(() => {
    resumeSocialLoginRedirect(window);

    // Going back to the start page may restore it from the back/forward cache, where effects do not run again
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        resumeSocialLoginRedirect(window);
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  return null;
};

export default SocialLoginHistoryResume;
